import ShipmentMarketing from './ShipmentMarketing'
import AddNewMarketingPid from './AddNewMarketingPid'
import MarketingList from './MarketingList'

ShipmentMarketing.AddNewMarketingPid = AddNewMarketingPid
ShipmentMarketing.MarketingList = MarketingList

export default ShipmentMarketing
